export default __webpack_public_path__ + "c4e9d10c60c734f96f6152dcf1d9db95.png";